/**
 * Clipboard Intelligence domain types.
 *
 * Clipboard history is global (an OS-level concept), not workspace-scoped.
 * Monitoring only ever runs with the user's explicit opt-in
 * (`settingsStore.clipboardMonitoringEnabled`) — see `ClipboardPage` and
 * `services/storage/clipboardRepository.ts`.
 */

export type ClipboardContentType = "text" | "url" | "code";

export interface ClipboardItem {
  readonly id: string;
  content: string;
  contentType: ClipboardContentType;
  pinned: boolean;
  readonly createdAt: number;
}

/** Regex patterns (as strings) matched against clipboard content before it's
 * stored; a match causes the item to be skipped entirely rather than
 * redacted, since a partially-redacted secret is still a leaked secret. */
export const DEFAULT_SENSITIVE_PATTERNS: string[] = [
  "\\b\\d{13,19}\\b", // card-number-shaped digit runs
  "-----BEGIN [A-Z ]+PRIVATE KEY-----",
  "\\b(?:sk|pk|rk)_(?:live|test)_[A-Za-z0-9]{16,}\\b", // common API-key shapes
];
